import BadgePoints from './badge-points';
import Lines from './lines';
import './styles.css';

export default function Summary({
  rank, 
  points,
  firstAttemptPoints,
  lines = [],
  onBadgeInfoButtonClick
}) {
  return (
    <div className="summary-info">
      <BadgePoints 
        rank={rank}
        points={points}
        firstAttemptPoints={firstAttemptPoints}
        onBadgeInfoButtonClick={onBadgeInfoButtonClick}
      />
      <Lines lines={lines} />
    </div>
  );
}
